import { useCookie as nuxtUseCookie } from '#app'

export interface CookieOptions {
    maxAge?: number // in seconds
    path?: string
    secure?: boolean
    sameSite?: 'lax' | 'strict' | 'none'
}

export function useAppCookie<T = string | null>(name: string, baseOptions?: CookieOptions) {
    const { public: pub } = useRuntimeConfig()
    /** Cookie `domain` for guest cart quote id; from `generateEnv` → `NUXT_PUBLIC_CART_DOMAIN`. */
    const cookieDomain = pub.cartDomain

    const defaultOptions = {
        path: '/',
        sameSite: 'lax',
        domain: cookieDomain,
        httpOnly: false,
        secure: false,
        ...baseOptions,
    }

    const cookie = nuxtUseCookie<T | null>(name, defaultOptions)

    const get = (): T | null => {
        return cookie.value
    }

    const set = (value: T) => {
        cookie.value = value
    }

    const remove = () => {
        cookie.value = null
    }

    const setIfExists = (value?: T) => {
        if (value !== undefined && value !== null) {
            set(value)
        } else {
            remove()
        }
    }

    return { set, setIfExists, get, remove }
}
